export default "__VITE_ASSET__CtJBT7GF__"